export const styles = (theme) => ({
  pointer: {
    cursor: 'pointer',
  },
})

export default styles
